export class SymbolPicker {
    static active_picker = null;

    constructor(initial_key, symbolsDict) {
        const symbol_keys = Object.keys(symbolsDict);
        if(initial_key && symbol_keys.includes(initial_key)) {
            this.current_key = initial_key;
        } else {
            this.current_key = symbol_keys[0];
        }

        this.symbols = symbolsDict;

        this.container_elem = null;
        this.btn_elem = null;
        this.tray_elem = null;
        this.display_elem = null;
        this.option_elems = [];
    }

    generateInput() {
        this.container_elem = document.createElement('div');
        this.container_elem.className = 'symbol-picker-container';

        this.container_elem.setAttribute('data-symbol-key', this.current_key);

        this.btn_elem = document.createElement('button');
        this.btn_elem.className = 'symbol-picker-btn';
        this.btn_elem.setAttribute('aria-haspopup', 'true');
        this.btn_elem.setAttribute('aria-expanded', 'false');
        this.container_elem.appendChild(this.btn_elem);

        this.display_elem = document.createElement('span');
        this.display_elem.className = 'selected-icon';
        this.display_elem.innerHTML = this.symbols[this.current_key];
        this.btn_elem.appendChild(this.display_elem);

        this.tray_elem = document.createElement('div');
        this.tray_elem.className = 'symbol-picker-tray';
        this.tray_elem.setAttribute('role', 'menu');
        this.container_elem.appendChild(this.tray_elem);

        for(const [key, symbol] of Object.entries(this.symbols)) {
            const option_button = document.createElement('button');
            option_button.className = 'icon-option';
            option_button.innerHTML = symbol;

            option_button.setAttribute('data-symbol-key', key);

            if(key === this.current_key) { option_button.classList.add('selected'); }

            option_button.addEventListener('click', (e) => {
                e.stopPropagation();
                this.setSymbol(key);
            });

            this.option_elems.push(option_button);
            this.tray_elem.appendChild(option_button);
        }

        this.btn_elem.addEventListener('click', (e) => {
            e.stopPropagation();
            const is_open = this.tray_elem.classList.contains('open');
            this[is_open ? 'closeTray' : 'openTray']();
        });

        document.addEventListener('click', (e) => {
            if(this.container_elem && !this.container_elem.contains(e.target)) {
                this.closeTray();
            }
        });

        return this.container_elem;
    }

    setSymbol(new_key) {
        this.current_key = new_key;
        this.display_elem.innerHTML = this.symbols[new_key];

        this.container_elem.setAttribute('data-symbol-key', new_key);

        for(const option_elem of this.option_elems) {
            const is_new_symbol = (option_elem.getAttribute('data-symbol-key') === new_key);
            option_elem.classList[is_new_symbol ? 'add' : 'remove']('selected');
        }

        this.closeTray();
    }

    openTray() {
        if(SymbolPicker.active_picker && SymbolPicker.active_picker !== this) { SymbolPicker.active_picker.closeTray(); }
        SymbolPicker.active_picker = this;

        this.tray_elem.classList.add('open');
        this.btn_elem.setAttribute('aria-expanded', 'true');
    }

    closeTray() {
        if(SymbolPicker.active_picker === this) { SymbolPicker.active_picker = null; }

        this.tray_elem.classList.remove('open');
        this.btn_elem.setAttribute('aria-expanded', 'false');
    }
}